import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';
import { plural } from '@cian/utils';
import { EStarSize, Stars } from '@cian/frontend-reviews-components';

import { REVIEWS_COUNT_PLURAL } from '../../../constants/reviews';
import * as style from './styles.css';

export interface IRatingsFilterButtonProps {
  reviewRate: number;
  reviewCount: number;
  checked: boolean | undefined;
  onClick(): void;
}

export const RatingsFilterButton: React.FC<IRatingsFilterButtonProps> = props => {
  const { reviewRate, reviewCount, onClick, checked } = props;

  return (
    <button data-testid="RatingsFilterButton" type="button" className={style['button']} onClick={onClick}>
      <div className={style['checkbox']}>
        <Checkbox checked={!!checked} onClick={e => e.preventDefault()} onChange={() => {}} />
      </div>
      <Stars value={reviewRate} size={EStarSize.M} />
      <span className={style['label']}>
        {reviewCount}&nbsp;{plural(reviewCount, REVIEWS_COUNT_PLURAL)}
      </span>
    </button>
  );
};
